import classes from "../../pages/MyProfile.module.scss";
import LoadingDots from "../UI/LoadingDots";
import { useState, useRef, useEffect, useContext, useCallback } from "react";
import { DDD, E2Data} from "../../lib/ddd/ddd";
import { useQuery } from '@tanstack/react-query'
import IssuingMode from "../servicesComponents/IssuingMode";
import { Container, Row } from "react-bootstrap";
import CompanyMode from "./CompanyMode";
import { OrgIdContext } from "../../store/orgId_context";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new DDD(apiRequestAddress);

const MoveToProduction = () => {
    const {connectionKey, isIntegrator, clientType, ISVCustomer} = useContext(OrgIdContext);

    return (
        <>
        <Container>
            <Row>
                <CompanyMode></CompanyMode>
            </Row>
        </Container>
        </>
    )
}

export default MoveToProduction;